import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";

Vue.use(VueAxios, Axios);

const db = getFirestore();

Vue.use(VueAxios, Axios);

const storageInstance = getStorage()
const storageImages = ref(storageInstance, "tipsImages/");

export default {
    state:{
        tipsList: [],
        loadingStatusTipImage:0,
        categoriesTipsList:[]
    },
    mutations:{
        SET_TIPS_LIST(state, tipsList){
            state.tipsList = tipsList
        },
        SET_CATEGORIES_TIPS_LIST(state, categoriesTipsList){
            state.categoriesTipsList = categoriesTipsList
        },
        SET_VALUE_LOADING_STATUS_TIP_IMAGE(state, progress) {
            state.loadingStatusTipImage = progress
        },
    },
    actions:{
                UploadImageTip({ commit }, tip) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `tipsImages/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, tip.image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        GetTipsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "tipsList"))
                    const tipsList = []
                    querySnapshot.forEach(async(doc) =>  {
                        let tip = doc.data()
                        let category = await getDoc(tip.category)
                        tip.category = category.data()
                        tipsList.push(tip)
                    })
                    commit('SET_TIPS_LIST', tipsList)
                    resolve(tipsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetTip({ }, tip){
            return new Promise(async (resolve, reject) => {
                try {
                    let resTip = await getDoc(doc(db, "tipsList", tip.id))
                    let gettedTip = resTip.data()
                    let category = await getDoc(gettedTip.category)
                    gettedTip.category = category.data()
                    resolve(gettedTip)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetCategoriesTipsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "categoriesTipsList"))
                    const categoriesTipsList = []
                    querySnapshot.forEach((doc) =>  {
                        categoriesTipsList.push(doc.data())
                    })
                    console.log(categoriesTipsList)
                    commit('SET_CATEGORIES_TIPS_LIST', categoriesTipsList)
                    resolve(categoriesTipsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateTip({}, tip) {
            return new Promise(async(resolve, reject) => {
                try {
                    delete tip.image.img
                                         tip.category = doc(db, "categoriesTipsList", tip.category.id);
                     const newDocRef = doc(collection(db, "tipsList"));
                     tip.id = newDocRef.id;
                     tip.createdAt = new Date()
                     tip.updatedAt = new Date()
                     await setDoc(newDocRef, tip)
                     resolve(newDocRef.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        CreateCategoryTip({}, categoryTip) {
            return new Promise(async(resolve, reject) => {
                try {
                                         const newDocRef = doc(collection(db, "categoriesTipsList"));
                     categoryTip.id = newDocRef.id;
                     await setDoc(newDocRef, categoryTip)
                     resolve(newDocRef.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        UpdateTip({}, tip) {
            return new Promise(async(resolve, reject) => {
                try {
                    if (tip.image.img) {
                        delete tip.image.img
                    }
                    if(tip.createdAt) {
                        delete tip.createdAt
                    }
                    tip.updatedAt = new Date()
                                         tip.category = doc(db, "categoriesTipsList", tip.category.id);
                    await updateDoc(doc(db, "tipsList", tip.id), tip)
                    resolve(tip.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        UpdateCategoryTip({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "categoriesTipsList", category.id), category)
                    resolve(category.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteTip({}, tip) {
            return new Promise(async(resolve, reject) => {
                try {
                                         let storageRefImage = ref(storageInstance, `tipsImages/${tip.image.ref}`);
                    await deleteObject(storageRefImage)
                    await deleteDoc(doc(db, "tipsList", tip.id))
                    resolve(tip.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteCategoryTip({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                    console.log('category', category)
                    await deleteDoc(doc(db, "categoriesTipsList", category.id))
                    resolve(category.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
    getters:{
        getTipsList(state){
            return state.tipsList;
        },
        getLoadingStatusTipImage(state){
            return state.loadingStatusTipImage;
        },
        getCategoriesTipsList(state){
            return state.categoriesTipsList;
        },
    }
}